import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDdIpxdnwvAMXaXdlZwKHdvnS3KVo1pptA",
  authDomain: "fir-inventory-1ee75.firebaseapp.com",
  projectId: "fir-inventory-1ee75",
  storageBucket: "fir-inventory-1ee75.appspot.com",
  messagingSenderId: "1035807575729",
  appId: "1:1035807575729:web:b8977a6722400a70881c90",
  measurementId: "G-JWM8JGY1WF"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
const db = getFirestore();
export default db;